module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news_big.9c682b77.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/maneuvers_bg_with_news_big.png
// module id = 3022
// module chunks = 11